// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ir83Z","logo":"styles_logo__8YkME","navLink":"styles_navLink__YxFCL"};